import React, {useState} from 'react';
import i18n from '../../i18n';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import FormField from '../Form/FormField';
import Grid from '@material-ui/core/Grid/Grid';
import {relations} from '../Form/utils';
import DeleteButton from '../Form/DeleteButton';
import FormSelect from '../Form/FormSelect';
import ContactLink from './FormFields/ContactLink';
import SaveEvent from '../SaveShortcut/FunctionComponent';


const FormFields = (props) => {

    const {
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        contactType,
        setFieldValue,
        formUrl,
        isEdit,
        isEmployee,
        newAddressNumbers
    } = props;

    SaveEvent({handleSubmit});

    const hasOwnAddress = !!values.street && !!values.city;
    const [addressNumber,setAddressNumber] = useState(values.address_number);
    const [street,setStreet] = useState(values.street || '');
    const [number,setNumber] = useState(values.number || '');
    const [zip,setZip] = useState(values.zip || '');
    const [city,setCity] = useState(values.city || '');

    const changeAddressNumber = e => {
        //let number = e.target ? e.target.value : e;
        setAddressNumber(newAddressNumbers[e]);
        setFieldValue('address_number',newAddressNumbers[e]);
    };
    const changeAddress = e => {
        //Object.keys(e).map(key => {
        ['street','number','zip','city'].map(key => {
            switch(key) {
                case 'street': setStreet( e[key] || values[key] ); break;
                case 'number': setNumber( e[key] || values[key] ); break;
                case 'zip': setZip( e[key] || values[key] ); break;
                case 'city': setCity( e[key] || values[key] ); break;
            }
            setFieldValue(key, e[key] || values[key]);
        });
    };

    return (
        <form method="POST" action={formUrl} onSubmit={handleSubmit} >
            <input type="hidden" name="contact_type" value={values.contact_type} onChange={handleChange}/>
            <Grid container spacing={8}>
                {values.is_company
                    ?(<React.Fragment>
                        <Grid item xs={12} sm={2}>
                            <FormField
                                type="text"
                                autoComplete={"off"}
                                name="address_number"
                                label={i18n.get('contacts.address_number')}
                                value={addressNumber}
                                //onChange={changeNumber}
                                onBlur={handleBlur}
                                error={errors.address_number}
                                touched={touched.address_number}
                                readOnly={true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormField
                                type="text"
                                autoComplete={"off"}
                                name="company_name"
                                label={i18n.get('contacts.company_name')}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.company_name}
                                error={errors.company_name}
                                touched={touched.company_name}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormSelect
                                type="text"
                                autoComplete={"off"}
                                name="type_of_relation"
                                label={i18n.get('contacts.relation.self')}
                                onChange={option => {
                                    setFieldValue('type_of_relation', option.value)
                                    changeAddressNumber(option.value === 'builder' ? 'AG' : 'NU')
                                }}
                                onBlur={handleBlur}
                                value={values.type_of_relation}
                                error={errors.type_of_relation}
                                touched={touched.type_of_relation}
                                options={relations()}
                            />
                        </Grid>
                    </React.Fragment>)
                    :(<Grid item xs={12}>

                        <ContactLink {...props}
                             changeAddress={changeAddress}
                             hasOwnAddress={hasOwnAddress}
                        />
                    </Grid>)
                }

                <Grid item xs={12}>
                    <FormField
                        type="text"
                        autoComplete={"off"}
                        name="description"
                        helperText={i18n.get('contacts.' + (contactType === 'craft' ? 'trade_helper_text' : 'scope_helper_text'))}
                        label={i18n.get('contacts.' + (contactType === 'craft' ? 'trade' : 'scope'))}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.description}
                        error={errors.description}
                        touched={touched.description}
                    />
                </Grid>

                {/*** German: Gewerk ***/}
                {contactType === 'craft' && (
                    <Grid item xs={12}>
                        <FormField
                            type="text"
                            name="department"
                            helperText={i18n.get('contacts.department_helper_text')}
                            label={i18n.get('contacts.department')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.department}
                            error={errors.department}
                            touched={touched.department}
                        />
                    </Grid>
                )}
                {!values.is_company && (
                    <React.Fragment>
                        <Grid item xs={12}>
                            {/*Divider*/}
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormSelect
                                type="text"
                                name="salutation"
                                label={i18n.get('contacts.salutation')}
                                onChange={option => setFieldValue('salutation', option.value)}
                                onBlur={handleBlur}
                                value={values.salutation}
                                error={errors.salutation}
                                touched={touched.salutation}
                                options={[
                                    {label: 'Herr', value: 'Herr'},
                                    {label: 'Frau', value: 'Frau'},
                                ]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormField
                                type="text"
                                name="first_name"
                                label={i18n.get('contacts.first_name')}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.first_name}
                                error={errors.first_name}
                                touched={touched.first_name}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormField
                                type="text"
                                name="last_name"
                                label={i18n.get('contacts.last_name')}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.last_name}
                                error={errors.last_name}
                                touched={touched.last_name}
                            />
                        </Grid>
                    </React.Fragment>
                )}
            </Grid>

            <React.Fragment>
                <Grid container spacing={8}>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormField
                            type="text"
                            autoComplete={"off"}
                            name="street"
                            label={i18n.get('contacts.street')}
                            onChange={e => {
                                changeAddress({street: e.target.value} )
                                setFieldValue('street',e.target.value)
                            }}
                            onBlur={handleBlur}
                            value={street}
                            error={errors.street}
                            touched={touched.street}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <FormField
                            type="text"
                            name="number"
                            label={i18n.get('contacts.number')}
                            onChange={e => {
                                changeAddress({number: e.target.value} )
                                setFieldValue('number',e.target.value)
                            }}
                            onBlur={handleBlur}
                            value={number}
                            error={errors.number}
                            touched={touched.number}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <FormField
                            type="text"
                            name="zip"
                            label={i18n.get('contacts.zip')}
                            onChange={e => {
                                changeAddress({zip: e.target.value} )
                                setFieldValue('zip',e.target.value)
                            }}
                            onBlur={handleBlur}
                            value={zip}
                            error={errors.zip}
                            touched={touched.zip}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormField
                            type="text"
                            name="city"
                            label={i18n.get('contacts.city')}
                            onChange={e => {
                                changeAddress({city: e.target.value} )
                                setFieldValue('city',e.target.value)
                            }}
                            onBlur={handleBlur}
                            value={city}
                            error={errors.city}
                            touched={touched.city}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={8}>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="landline"
                            label={i18n.get('contacts.landline')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.landline}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="mobile"
                            label={i18n.get('contacts.mobile')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.mobile}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="email"
                            name="email"
                            label={i18n.get('contacts.email')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            error={errors.email}
                            touched={touched.email}
                            readOnly={ isEmployee }
                        />
                    </Grid>
                </Grid>
            </React.Fragment>

            {props.children}

            <Grid container spacing={8} justify="space-between" alignItems="center" style={{paddingTop: 8}}>
                <Grid item>
                    {isEdit && (
                        <DeleteButton
                            href={`/contacts/${values.id}`}
                            confirmMessage={i18n.get('contacts.confirm_message')}
                            successMessage={i18n.get('contacts.delete_success_message')}
                            handleSuccess={ () => { values.is_company
                                ? location.assign( `/contacts/search/crafts` )
                                : location.assign( props.redirectAfterSubmit )
                            } }
                        />
                    )}
                </Grid>

                <Grid item xs={12} sm={3} align={'right'}>

                </Grid>

                <Grid item>
                    { (values.id && !values.parent_id && values.is_company) && (
                        <Button size={"small"}
                                variant={"contained"}
                                href={`/contacts/person/create?parent_id=${values.id}`}
                                color={"primary"}
                                style={{marginRight:10}}>
                            <Icon fontSize="small">add</Icon>
                            &nbsp;
                            {i18n.get('contacts.add')}
                        </Button>
                    )}
                    { !isEdit && values.is_company &&(
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                type="submit"
                                onClick={() => setFieldValue('new_contact',true)}
                                style={{marginRight:10}}
                        >
                            <Icon fontSize="small">add</Icon>
                            &nbsp;
                            {i18n.get('contacts.add')}
                        </Button>
                    )}
                    <Button size="small"
                            variant="contained"
                            color="primary"
                            type="submit"
                            onClick={() => setFieldValue('new_contact',false)}
                    >
                        <Icon fontSize="small">save</Icon>
                        &nbsp;
                        {i18n.get('contacts.save')}
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

export default FormFields;
